import _ from 'lodash'
import { FETCH_SHIP_FROM_ADDRESSES } from '../actions/types'

export default (state = [], action) => {
  switch (action.type) {
    case FETCH_SHIP_FROM_ADDRESSES:
      return action.payload
    default:
      return state
  }
}
